export interface HcSchedule {
  days: DayOfWeek[];
  times: TimeSlot[];
  /** Extra loved-one outreach attempts after no reply (SMS/voice); not `notificationSetup.maxRetries`. */
  retries: number;
  window: number; // in minutes
  timezone: string; // IANA timezone identifier (e.g., 'America/New_York', 'UTC')
}

export enum DayOfWeek {
  SUNDAY = 'schedule.day.sunday',
  MONDAY = 'schedule.day.monday',
  TUESDAY = 'schedule.day.tuesday',
  WEDNESDAY = 'schedule.day.wednesday',
  THURSDAY = 'schedule.day.thursday',
  FRIDAY = 'schedule.day.friday',
  SATURDAY = 'schedule.day.saturday'
}

export interface TimeSlot {
  hour: number; // 0-23 local (schedule timezone)
  minute: number; // 0-59 local
  utcTimeMinutes: number; // UTC time in minutes since midnight (0-1439)
  /** Set by backend on save; optional when sending from client. */
  hourUTC?: number; // 0-23 UTC hour
  /** Set by backend on save; optional when sending from client. */
  minuteUTC?: number; // 0-59 UTC minute
}

/*
// Example MongoDB query
const currentUtcMinutes = HcScheduleUtil.getCurrentUtcTimeMinutes();
const windowMinutes = 5; // or from your schedule

// Find all flows that should run now
const flowsToRun = await FlowModel.find({
  'schedule.times.utcTimeMinutes': {
    $gte: currentUtcMinutes - windowMinutes,
    $lte: currentUtcMinutes + windowMinutes
  }
});

*/
